import HView from "../HView";
import { PageEnum } from "@/enums/pageEnum";
import { useTranslation } from "react-i18next";

const Header = ({ data }: { data: any }) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-start pt-4 pb-6 border-b border-[#E8E9ED] dark:border-[#ffffff21] mb-6">
      <div className="w-[300px]">
        {t("lift")}:{" "}
        <HView
          name={data?.liftName}
          isNewWindow
          path={`${PageEnum.LIFT}/detail/${data?.liftId}`}
        />
      </div>
      <div className="flex-1">
        {t("LMD ID")}:{" "}
        <HView
          name={data?.lmdName}
          isNewWindow
          path={`${PageEnum.LMD}/detail/${data?.lmdId}`}
        />
      </div>
      <div className="flex-1 flex justify-end gap-1">
        <div>{t("address")}:</div>
        <div>{data?.lmdAddress}</div>
      </div>
    </div>
  );
};

export default Header;
